// @flow

import React, { Suspense } from 'react';

import { relevantTodoDashboardPermissions } from './constants';
import LoadingIndicator from '../../components/LoadingIndicator';
import useAuth from '../../hooks/useAuth';

const Alerts = React.lazy(() => import('./index'));
const TodoDashboard = React.lazy(() => import('./TodoDashboard'));

const AlertsLoadable = () => {
  const { user } = useAuth();
  const { role: { permissions = [] } = {} } = user || {};

  const showNewToDoPage = permissions.some(({ name: permissionName }) =>
    relevantTodoDashboardPermissions.includes(permissionName),
  );

  return (
    <div>
      <Suspense fallback={<LoadingIndicator />}>{showNewToDoPage ? <TodoDashboard /> : <Alerts />}</Suspense>
    </div>
  );
};

export default AlertsLoadable;
